import { useContext, useEffect } from "react";
import { scrollIntoView } from "../../styledSelect/hooks/useScroll";
import { USelectContext } from "../context/context";
export const useOptionsScroll = ({ dropdownRef, highlighted, value, }) => {
    const { showDropdown } = useContext(USelectContext);
    const scroll = (id, el, dataset = "data-index") => {
        if (!id)
            return;
        const optionEl = el?.querySelector(`[role="option"][${dataset}="${id}"]`);
        if (optionEl && el) {
            scrollIntoView(optionEl, el);
        }
    };
    useEffect(() => {
        scroll(highlighted, dropdownRef?.current, "data-value");
    }, [dropdownRef, highlighted]);
    useEffect(() => {
        if (!showDropdown)
            return;
        const lastValue = value?.[value.length - 1]?.value;
        scroll(lastValue, dropdownRef?.current, "data-value");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDropdown]);
};
